"use client";
import { getStrapiMedia } from '@/app/lib/api-helpers';
import { getYouTubeEmbeddedUrl } from '@/app/utils/commonUtils';
import Image from 'next/image';
import React from 'react';

interface CardProps {
    data: any;
}

const Card = (props: CardProps) => {
    const { data } = props;
    const imgUrl = getStrapiMedia(data?.icon?.data?.attributes?.url);

    const getThumbnail = () => {
        if (data.href.includes('youtube') || data.href.includes('youtu.be')) {
            const thumbnailUrl = getYouTubeEmbeddedUrl(data.href);
            return <iframe src={thumbnailUrl} className="w-full h-full rounded-md" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
        }
        return <a href={data.href || ''} rel="noopener noreferrer" className="w-full cursor-pointer">
            <Image src={imgUrl ?? ""} alt={data.title || ''} className="w-full object-contain rounded-md" width={320} height={170} />
        </a>
    }
    return (
        <div className="w-full max-w-[340px] h-[370px] bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow duration-300">
            <div className="p-[10px] flex justify-center items-center">
                {getThumbnail()}
            </div>

            <div className="p-5 pt-[10px] space-y-3 h-[180px] flex flex-col overflow-hidden w-fit">
                <span className="bg-[#032D60] text-white text-[14px] font-semibold px-2 py-1 flex-shrink-0 self-start">
                    {data.title}
                </span>

                <h3 className="flex-1">
                    <div className="text-[18px] text-[#000000] line-clamp-3 text-ellipsis">
                        {data.description}
                    </div>
                </h3>

                <div className="pt-1 flex-shrink-0">
                    <a
                        href={data.href || ''}
                        rel="noopener noreferrer"
                        className="text-[#032D60] font-semibold text-[14px] inline-flex items-center gap-2 hover:text-[#3AB5FC] transition-colors"
                    >
                        {data.footerText}
                        <Image src="/images/arrowWithBackground.svg" alt="Arrow Right" width={18} height={18} />
                    </a>
                </div>
            </div>
        </div>
    );
};


export default Card;